import script from "./ProjectScheduledLifecycleSetter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectScheduledLifecycleSetter.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__